import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wallet-section',
  templateUrl: './wallet-section.component.html',
  styleUrls: ['./wallet-section.component.scss']
})
export class WalletSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
